import { render, staticRenderFns } from "./ScreenshotDialog.vue?vue&type=template&id=96e87b04&scoped=true&"
import script from "./ScreenshotDialog.vue?vue&type=script&lang=ts&"
export * from "./ScreenshotDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenshotDialog.vue?vue&type=style&index=0&id=96e87b04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e87b04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VDialog,VImg})
